module.exports = __webpack_public_path__ + "img/fork.be5030ca.webp";